// extracted by mini-css-extract-plugin
export default {"cardContentWrap":"styles_cardContentWrap__qyZ4D"};